export default "__VITE_ASSET__BxM5U2$L__"